module.exports = __webpack_public_path__ + "static/media/firmaEmail.c838e31f.png";